const CARD_BACKGROUND_COLOR: "gray" | "slate" | "stone" | "neutral" = "neutral";

export const CARD_BG = getCardBackground(CARD_BACKGROUND_COLOR);

function getCardBackground(
  color: "gray" | "slate" | "stone" | "neutral",
): string {
  const backgrounds = {
    gray: "bg-[#FCFDFD] dark:bg-[#4A4040]",
    slate: "bg-[#FCFDFE] dark:bg-[#4A4040]",
    stone: "bg-[#FDFDFC] dark:bg-[#4A4040]",
    neutral: "bg-[#FDFDFD] dark:bg-[#4A4040]",
  };

  return backgrounds[color];
}

export const PAGE_BG = "bg-white dark:bg-[#2C2525]";

export const BORDER = "border-gray-200 dark:border-[#5B5353]";

export const SHADOW = {
  card: "shadow-sm hover:shadow-md transition-shadow",
  // Legacy alias retained for existing callers; it intentionally matches card.
  cardHover: "shadow-sm hover:shadow-md transition-shadow",
  cardElevated: "shadow-lg",
  cardOverlay: "shadow-xl",
  sidebar: "shadow-2xl",
};

export const TEXT = {
  primary: "text-gray-900 dark:text-[#FFF8F9]",
  secondary: "text-gray-600 dark:text-[#B5A9AA]",
  tertiary: "text-gray-500 dark:text-[#B5A9AA]",
};
